/**
 * 【后端别名映射关系配置】,需前端开发者填写
 * 格式:Map<endAlias,frontAlias>,举例:endAliasMap.set('int_1', 'contactStatus'),代表后端的【int_1】属性与前端的【contactStatus】属性相匹配
 */
const endAliasMap = new Map()
// endAliasMap.set('string_1', 'clientName') // 企业联系人名字
// endAliasMap.set('string_2', 'clientPosition') // 企业联系人职位

/**
 * 【前端别名映射关系配置】,会根据【后端别名映射关系配置】自动生成
 */
const frontAliasMap = new Map()
endAliasMap.forEach((value, key) => {
  frontAliasMap.set(value, key)
})

/**
 * 租户表信息别名转换工具
 * @param {string} covertType 本次转换所属类型(2种):FrontToEnd/EndToFront(前端参数->后端参数 OR 后端参数->前端参数)
 * @param {object} obj 本次要转换的对象,特别注意:只能是【对象数组】或者【单个对象】两种类型!!!
 * @returns {objct} obj 返回原对象
 */
export function convertAliasField(covertType, obj) {
  if (obj instanceof Array) {
    // 如果是对象数组,则依次遍历数组内的每个对象
    for (const item of obj) {
      // 遍历对象属性,发现有对应映射关系的属性名,则动态该属性名字
      for (const key in item) {
        if (covertType === 'EndToFront') {
          // 如果是[后端参数->前端参数]
          if (endAliasMap.get(key)) {
            item[endAliasMap.get(key)] = item[key] // 添加一个别名属性
            delete item[key] // 剔除原属性
          }
        } else if (covertType === 'FrontToEnd') {
          // 如果是[前端参数->后端参数]
          if (frontAliasMap.get(key)) {
            item[frontAliasMap.get(key)] = item[key] // 添加一个别名属性
            delete item[key] // 剔除原属性
          }
        }
      }
    }
  } else {
    // 如果是对象,则直接依次遍历对象属性
    for (const key in obj) {
      if (covertType === 'EndToFront') {
        // 如果是[后端参数->前端参数]
        if (endAliasMap.get(key)) {
          obj[endAliasMap.get(key)] = obj[key] // 添加一个别名属性
          delete obj[key] // 剔除原属性
        }
      } else if (covertType === 'FrontToEnd') {
        // 如果是[前端参数->后端参数]
        if (frontAliasMap.get(key)) {
          obj[frontAliasMap.get(key)] = obj[key] // 添加一个别名属性
          delete obj[key] // 剔除原属性
        }
      }
    }
  }
  return obj
}
